import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class InvalidMobileErrorService {
    constructor(private translate: TranslateService){}

    getErrorMessage(error){
        let errMsg = error.Message;
        if(error.Code == '1024'){
          let splitStrings: string[] = errMsg.split('.');

          if (splitStrings.length >= 2) {
              let firstPart = `${this.translate.instant('pages.createReceiptPage.errorMsgs.invalidPhoneNumber')}`;
              let secondPart = splitStrings[1] + ".";
              if(secondPart == " Phone number is required."){
                secondPart = `${this.translate.instant('pages.createReceiptPage.errorMsgs.reqPhoneNumber')}`;
              }
              else if(secondPart == " Phone number is too long."){
                secondPart = `${this.translate.instant('pages.createReceiptPage.errorMsgs.tooLongPhoneNumber')}`;
              }
              else if(secondPart == " Phone number is too short."){
                secondPart = `${this.translate.instant('pages.createReceiptPage.errorMsgs.shortPhoneNumber')}`;
              }
              else if(secondPart == " Number has extra digits."){
                secondPart = `${this.translate.instant('pages.createReceiptPage.errorMsgs.extraDigitPhoneNumber')}`;
              }
              else if(secondPart == " Could not find a matching phone numbering plan."){
                secondPart = `${this.translate.instant('pages.createReceiptPage.errorMsgs.numberingPlanError')}`;
              }
              else if(secondPart == " Number has missing digits."){
                secondPart = `${this.translate.instant('pages.createReceiptPage.errorMsgs.missingDigitError')}`;
              }
              errMsg = firstPart + secondPart;
          }
        }
        return errMsg;
    }
}
